// src/language/ko.js
// 定义韩文语言包对象
export default {
  下载中心: "下载中心",
  修改密码: "修改密码",
  退出登录: "退出登录",
  首页: "首页",
  查询: "查询",
  重置: "重置",
  新增: "新增",
  编辑: "编辑",
  删除: "删除",
  保存: "保存",
  取消: "取消",
  确定: "确定",
  详情: "详情",
  请输入: "请输入{text}",
  类型: "类型",
  标签: "标签",
  值: "值",
  描述: "描述",
  排序: "排序",
  创建时间: "创建时间",
  操作: "操作",
  提示: "提示",
  新增根菜单: "新增根菜单",
  新增子菜单: "新增子菜单",
  类型群组: "类型群组",
  成长路径: "成长路径",
  代理商简称: "代理商简称",
  启用: "启用",
  禁用: "禁用",
  操作成功: "操作成功",
  "操作失败,请稍后再试": "操作失败,请稍后再试",
  确认执行此操作: "确认执行此操作",
  关键字搜索: "",
  根据关键字模糊搜索: "",
  请选择类型群组: "",
  请选择: "",
  一级分类: "",
  请选择一级分类: "",
  二级分类: "",
  请选择二级分类: "",
  三级分类: "",
  请选择三级分类: "",
  是否发布: "",
  请选择是否发布: "",
  是: "",
  否: "",
  创建: "",
  批量发布: "",
  批量取消发布: "",
  取消发布: "",
  发布: "",
  复制: "",
  成绩: "",
  批量更新学员成绩: "",
  课程名称: "",
  文件: "",
  选择文件: "",
  下载模版: "",
  请先上传导入文件: "",
  更新成功: "",
  学员模版下载: "",
  请先选择要发布的课程: "",
  确认发布当前选中的课程吗: "",
  发布成功: "",
  请先选择要取消发布的课程: "",
  确认取消发布当前选中的课程吗: "",
  取消发布成功: "",
  确认变更发布状态吗: "",
  编辑成功: "",
  确认复制该课程: "",
  确认删除此课程吗: "",
  删除成功: "",
  一级标签: "",
  二级标签: "",
  三级标签: "",
  评分: "",
  状态: "",
  章节数: "",
  所有者: "",
  发布日期: "",
  创建日期: "",
  输入任意内容: "",
  暂无数据: "",
  登录失效: "",
  "服务器繁忙，请稍后重试": "",
  网络错误: "",
  "网络错误，请检查您的网络连接": "",
  确认删除此卡片吗: "",
  标题: "",
  请输入标题: "",
  简介: "",
  请输入简介: "",
  权益列表: "",
  图标: "",
  加红标题: "",
  内容: "",
  请输入内容: "",
  保存成功: "",
  不能添加空卡片: "",
  请输入邀请码核销提示文案: "",
  证书列表: "",
  合作伙伴列表: "",
  请输入个人支付提示文案: "",
  更多认证封面: "",
  更多认证简介: "",
  请输入更多认证简介: "",
  代理商信息完善: "",
  文案: "",
  请输入文案: "",
  "代理商课程中心提示文案": "",
  "先人一步，现在就开始了解出海学堂": "",
  人才认证: "",
  认证体系: "",
  官方证书: "",
  认证权益: "",
  合作伙伴: "",
  个人支付提示文案: "",
  邀请码核销提示文案: "",
  课程中心: "",
  导入: "",
  编辑类型群组: "",
  添加主体信息: "",
  编辑主体信息: "",
  新增菜单: "",
  别名: "",
  编辑菜单: "",
  "注:数字越小越靠前": "",
  新增类型群组: "",
  新增主体信息: "",
  类型群组名称: "",
  主体名称: "",
  编辑二级群组: "",
  二级群组名称: "",
  导入主体信息: "",
  适用人群: "",
  请选择适用人群: "",
  主体信息模版下载: "",
  请选择主体信息适用人群: "",
  请输入名称: "",
  请输入别名: "",
  确认提交吗: "",
  新增成功: "",
  确认删除该记录吗: "",
  确认启用吗: "",
  确认禁用吗: "",
  启用成功: "",
  禁用成功: "",
  请输入代理商简称: "",
  邮箱后缀: "",
  "排序 (正序排列)": "",
  新增代理商简称: "",
  编辑代理商简称: "",
  代理商简称模版下载: "",
  请选择代理商简称适用人群: "",
  请输入邮箱后缀: "",
  Banner图片: "",
  跳转地址: "",
  位置: "",
  创建人: "",
  新增Banner: "",
  PC端图片: "",
  建议尺寸: "",
  Mobile端图片: "",
  请选择显示位置: "",
  编辑Banner: "",
  请上传PC端图片: "",
  请输入排序: "",
  请选择位置: "",
  确认发布该Banner吗: "",
  确认取消发布该Banner吗: "",
  取消成功: "",
  刷新列表: "",
  归属模块: "",
  文件名称: "",
  开始时间: "",
  完成时间: "",
  下载: "",
  关键字检索: "",
  请输入关键字检索: "",
  问题: "",
  是否推荐: "",
  回答: "",
  请输入问题: "",
  请输入回答: "",
  请选择是否推荐: "",
  编辑字典: "",
  原密码: "",
  新密码: "",
  确认密码: "",
  确认退出登录吗: "",
  "对不起，您没有权限": "",
  "欢迎进入 TikTok for Business 出海学堂 管理平台": "",
  "根据UID、学员名称模糊搜索": "",
  证书名称: "",
  请输入证书名称: "",
  证书编号: "",
  请输入证书编号: "",
  证书来源: "",
  请选择证书来源: "",
  证书状态: "",
  请选择证书状态: "",
  导出: "",
  颁发证书: "",
  学员自考: "",
  手工颁发: "",
  证书撤回: "",
  认证证书: "",
  请选择证书: "",
  学员信息: "",
  学员UID: "",
  学员名称: "",
  "注：1.请确保平台已录入学员UID信息": "",
  "2.每次最多批量添加5个学员证书": "",
  提交: "",
  请输入撤回原因: "",
  确认撤回: "",
  添加成功: "",
  请检查信息填写是否正确: "",
  证书封面: "",
  有效期: "",
  核销方式: "",
  邀请码: "",
  生效时间: "",
  备注: "",
  添加二级: "",
  添加三级: "",
  标签名称: "",
  请输入标签名称: "",
  确认删除此标签: "",
  标签编辑: "",
  状态编辑成功: "",
  标签新增: "",
  证书系列: "",
  请选择证书系列: "",
  认证等级: "",
  请选择认证等级: "",
  认证及格分: "",
  及格分: "",
  证书费用: "",
  价格: "",
  证书优惠费用: "",
  证书优惠时间: "",
  请选择时间: "",
  报名时间: "",
  至: "",
  结束时间: "",
  请选择发布日期: "",
  自动发布: "",
  证书有效期: "",
  请输入证书有效期: "",
  "单位：月": "",
  报名类型: "",
  请选择报名类型: "",
  封面图: "",
  证书模板底图: "",
  证书简介: "",
  请输入证书简介: "",
  证书详情: "",
  请输入证书详情: "",
  下一步: "",
  返回列表: "",
  请选择认证课程: "",
  请输入认证及格分: "",
  请上传封面图: "",
  请上传详情介绍图: "",
  请上传证书模板底图: "",
  请输入考试星邀请码地址: "",
  请输入考试星付费报名地址: "",
  请输入考试星考试地址: "",
  请输入考试星appId: "",
  请输入考试星appKey: "",
  优惠价格必须包含截止时间: "",
  确认重置内容吗: "",
  请输入课程名称: "",
  课程反馈跳转链接: "",
  请输入反馈跳转链接: "",
  是否为全必修: "",
  章节标签管理: "",
  创建章节: "",
  视频: "",
  上一步: "",
  章节标题: "",
  请输入章节标题: "",
  章节描述: "",
  请输入章节描述: "",
  章节标签: "",
  请选择章节标签: "",
  课件类型: "",
  请选择课件类型: "",
  课件: "",
  请输入课程视频地址: "",
  课程资料: "",
  请选择资料类型: "",
  链接: "",
  请输入课程资料名称: "",
  请输入课程资料地址: "",
  删除资料: "",
  添加新资料: "",
  允许资料下载: "",
  小节考试类型: "",
  请选择完课考试类型: "",
  内部: "",
  外链: "",
  小节考试链接: "",
  请输入完课考试链接: "",
  小节考试试卷: "",
  请选择小节考试试卷: "",
  章节详情: "",
  查看课件: "",
  课件大小: "",
  查看课程资料: "",
  浏览量: "",
  打开小节考试链接: "",
  标签是否启用: "",
  编辑章节标签: "",
  请输入章节标签名称: "",
  新增章节标签: "",
  确认删除当前标签吗: "",
  章节编辑: "",
  请输入视频地址: "",
  请选择视频时长: "",
  确认删除当前章节吗: "",
  章节新增: "",
  章节名称: "",
  请输入一级分类: "",
  请输入课程封面图: "",
  请输入课程介绍: "",
  邀请码报名标识: "",
  付费报名标识: "",
  考试星appId: "",
  "注：此信息由考试星提供": "",
  考试星appKey: "",
  考试星邀请码地址: "",
  考试星付费报名地址: "",
  考试星考试地址: "",
  复制成功: "",
  根据名称模糊搜索: "",
  请选择状态: "",
  初级: "",
  中级: "",
  高级: "",
  认证课程: "",
  考试星配置: "",
  确认复制此认证信息吗: "",
  确认删除此信息吗: "",
  级别: "",
  完善证书信息: "",
  完善课程信息: "",
  完善考试星信息: "",
  "根据UID、名称、邀请码模糊搜索": "",
  核销类型: "",
  请选择核销类型: "",
  考试星UID: "",
  手机号码: "",
  身份证号码: "",
  邮箱: "",
  考试名称: "",
  考试成绩: "",
  开考时间: "",
  交卷时间: "",
  "考试时长（分钟）": "",
  考试结果: "",
  强制交卷: "",
  数据来源: "",
  成绩回传时间: "",
  UID搜索: "",
  邀请码搜索: "",
  关联证书: "",
  请选择关联证书: "",
  废弃: "",
  邀请码个数: "",
  请输入数量: "",
  请填写有效期: "",
  邀请码生成模版下载: "",
  生成成功: "",
  延期: "",
  确认废弃此邀请码吗: "",
  使用时间: "",
  创建复审: "",
  明细: "",
  作废: "",
  复审: "",
  认证考试: "",
  审核状态: "",
  通过: "",
  不通过: "",
  复审原因: "",
  请输入复审原因: "",
  成绩复审明细: "",
  学员数量: "",
  与考试星差异数量: "",
  自动审核: "",
  忽略: "",
  恢复: "",
  认证信息: "",
  请选择认证信息: "",
  考试ID: "",
  请输入考试ID: "",
  点击查看如何获取考试ID: "",
  获取考试ID: "",
  "1、登录考试星管理后台": "",
  账号密码由考试星提供: "",
  "2、在左侧菜单点击【考试管理】进入考试列表，选择对应的考试信息，": "",
  "在右侧点击【编辑】按钮，打开考试编辑页面，在地址栏中复制考试ID。": "",
  参考如下图: "",
  确认作废当前的复审吗: "",
  已作废: "",
  请填写考试相关信息: "",
  确认对当前认证考试学员成绩进行复审吗: "",
  复审操作已提交: "",
  自动审核成功: "",
  考试场次: "",
  回传成绩: "",
  回传结果: "",
  回传作弊状态: "",
  考试星成绩: "",
  考试星结果: "",
  考试星作弊状态: "",
  批次号: "",
  差异数量: "",
  复审状态: "",
  复审时间: "",
  "根据UID、学员名称、邀请码模糊搜索": "",
  请选择审核状态: "",
  个人支付: "",
  匹配学员成绩: "",
  批量审核: "",
  异常数据: "",
  前置数据: "",
  原因: "",
  正常: "",
  审核: "",
  查询报名结果: "",
  更新学员名称: "",
  禁用考试星账号: "",
  历史: "",
  事件时间: "",
  请选择事件时间: "",
  执行: "",
  关闭: "",
  更新: "",
  成绩审核: "",
  理由: "",
  消息体: "",
  查看: "",
  记录: "",
  考试记录: "",
  认证记录: "",
  "注:确认执行后由服务端自动审核,请关注页面数据变化": "",
  查询阶段: "",
  考试期间: "",
  考试结束: "",
  查询学员报名结果: "",
  报名ID: "",
  请输入报名ID: "",
  点击查看如何获取报名ID: "",
  提交开始时间: "",
  选择开始时间: "",
  提交结束时间: "",
  选择结束时间: "",
  获取报名ID: "",
  "1、登录出海学堂运营管理端,在菜单中选择【】进入列表页面,选择对应得认证信息，点击【编辑】按钮进入编辑页面。":
    "",
  "2、在编辑页面中，滑动至【考试星邀请码地址】属性，复制考试星地址中的报名ID数值,参考示例如下":
    "",
  确认执行操作: "",
  确认禁用当前学员考试星账号: "",
  请选择要审核的证书: "",
  请填写报名相关信息: "",
  确认查询相关考试学员报名结果吗: "",
  报名结果查询已提交: "",
  确认匹配相关考试学员成绩吗: "",
  匹配申请已提交: "",
  确认废弃当前记录吗: "",
  请先选择要操作的学员: "",
  请说明不通过理由: "",
  确认执行不通过操作: "",
  确认执行通过操作: "",
  审核成功: "",
  待报名时间: "",
  审核时间: "",
  信息完善时间: "",
  回传成绩时间: "",
  作废时间: "",
  考试时间: "",
  复审回调: "",
  考试星注册信息: "",
  考试星成绩信息: "",
  异常原因: "",
  场次ID: "",
  场次名称: "",
  审核人: "",
  考试星账号状态: "",
  考试星考试结果: "",
  强制交卷状态: "",
  基本信息: "",
  实际评分: "",
  虚拟评分: "",
  实际浏览量: "",
  虚拟浏览量: "",
  课程介绍: "",
  讲师团队: "",
  未发布: "",
  开始学习时间: "",
  已学习章节: "",
  完课率: "",
  请先选择要发布的章节: "",
  确认发布当前选中的章节吗: "",
  请先选择要取消发布的章节: "",
  确认取消发布当前选中的章节吗: "",
  课程信息: "",
  课程内容: "",
  学员: "",
  编辑课程: "",
  返回: "",
  海报图: "",
  请输入讲师团队: "",
  课程实际评分: "",
  课程虚拟评分: "",
  是否显示: "",
  课程实际浏览量: "",
  课程虚拟浏览量: "",
  返回列表当前内容将不会保留: "",
  课程分类: "",
  日历标签: "",
  请选择日历标签: "",
  新增标签: "",
  "请输入标签值（与其他标签值不能相同）": "",
  请输入标签描述: "",
  编辑标签: "",
  请输入标签值: "",
  "海报-PC端": "",
  "注: 图片尺寸比例为16 : 9": "",
  "海报-Mobile端": "",
  起止时间: "",
  外链地址: "",
  请输入外链地址: "",
  编辑直播海报: "",
  请上传pc端海报: "",
  确认删除当前直播吗: "",
  新增直播海报: "",
  报名地址: "",
  时间: "",
  预约时间: "",
  "根据课程名称、学员模糊搜素": "",
  评分时间: "",
  "根据课程、章节、学员模糊搜索": "",
  建议: "",
  提交时间: "",
  是否回复: "",
  撤回: "",
  回复: "",
  管理员回复: "",
  请输入评论回复: "",
  确认发布该条建议吗: "",
  确认撤回该条建议吗: "",
  回复成功: "",
  请选择一级标签: "",
  请选择二级标签: "",
  选择课程: "",
  请搜索选择要添加的课程: "",
  官方推荐: "",
  精品课程: "",
  继续操作此课程将不属于精品推荐课程: "",
  确认从游客课程中移除此课程吗: "",
  试听: "",
  时间范围: "",
  新增学员: "",
  新增完成学员: "",
  新增学员完成率: "",
  课程内容完成情况: "",
  学员人数: "",
  完成人数: "",
  完成率: "",
  人均学习时长: "",
  总学习时长: "",
  已完成: "",
  学习中: "",
  未开始: "",
  课程: "",
  点赞数: "",
  收藏数: "",
  建议数: "",
  "章节数(已学/总章节)": "",
  "学习时长(小时)": "",
  加入时间: "",
  学员类型: "",
  总体数据: "",
  增量数据: "",
  姓名: "",
  请输入姓名: "",
  请输入主体名称: "",
  请输入UID: "",
  学员类别: "",
  内部员工: "",
  导出全部: "",
  主体信息: "",
  加入在线课: "",
  完成在线课: "",
  在线学习时长: "",
  学员列表: "",
  点击下载学员报表: "",
  试卷标题: "",
  输入试卷标题搜索: "",
  试卷状态: "",
  请选择试卷状态: "",
  新建试卷: "",
  分: "",
  学员成绩: "",
  确认启动当前试卷: "",
  确认禁用当前试卷: "",
  总分: "",
  版本号: "",
  考试时长: "",
  试卷及格分: "",
  分数: "",
  考试次数: "",
  维度标签: "",
  请选择维度标签: "",
  请输入试卷简介: "",
  题目导入: "",
  全部题库: "",
  添加题目: "",
  题目: "",
  题目类型: "",
  请选择题目类型: "",
  题目内容: "",
  请输入题目内容: "",
  题目图片: "",
  整体解析: "",
  请输入整体解析: "",
  题目分数: "",
  添加选项: "",
  选项内容: "",
  请输入选项内容: "",
  批量导入题目: "",
  题目导入模版: "",
  请输入考试时间: "",
  请输入正确的考试时间: "",
  请输入试卷标题: "",
  请输入试卷及格分: "",
  请输入试卷考试次数: "",
  请选择试卷考试时间: "",
  请输入考试时长: "",
  请输入考试分数: "",
  单选题: "",
  多选题: "",
  判断题: "",
  请先添加题目: "",
  编辑试卷成功: "",
  添加试卷成功: "",
  确认删除当前问题: "",
  正确: "",
  错误: "",
  请选择答案: "",
  请输入正确的题目分数: "",
  多选题至少选择两个正确选项: "",
  请完整添加选项: "",
  删除当前推荐课: "",
  课程标签: "",
  学员考试记录: "",
  学员答题详情: "",
  试卷时间: "",
  答题时长: "",
  问题答案: "",
  全部题目: "",
  得分: "",
  是否及格: "",
  提交方式: "",
  添加: "",
  配置推荐课: "",
  直播间名称: "",
  输入直播间名称搜索: "",
  直播中: "",
  预告: "",
  回放: "",
  结束: "",
  未置顶: "",
  置顶: "",
  信息复制: "",
  配置更多: "",
  同步直播状态: "",
  白名单: "",
  取消置顶: "",
  二维码: "",
  直播上架: "",
  直播下架: "",
  直播白名单: "",
  白名单校验: "",
  白名单UID: "",
  "请输入学员UID（多个学员逗号分隔）": "",
  请输入直播间名称: "",
  横屏直播封面: "",
  "注: 横屏尺寸建议为1920*1080 支持jpg,png,jpeg格式，图片大小不超出2M": "",
  竖屏直播封面: "",
  "注: 竖屏尺寸建议为1125*2250 支持jpg,png,jpeg格式，图片大小不超出2M": "",
  直播时间: "",
  请选择直播开始时间: "",
  "更多详细配置,请移步至火山引擎控制台进行配置": "",
  地址: "",
  直播信息: "",
  "观看限制-自定义信息": "",
  登录账号APP: "",
  出海学堂直播: "",
  登录链接: "",
  错误重定向地址: "",
  直播间地址信息: "",
  web开播地址: "",
  "直播推流-主流服务器地址": "",
  "直播推流-主流密钥": "",
  "直播推流-备流服务器地址": "",
  "直播推流-备流密钥": "",
  的二维码: "",
  直播间二维码: "",
  请输入要添加的学员UID: "",
  确认将此学员从白名单中移除吗: "",
  同步成功: "",
  编辑直播: "",
  请上传横屏封面: "",
  请上传竖屏封面: "",
  直播状态: "",
  是否置顶: "",
  第一次登录时间: "",
  已学课程数: "",
  邮箱地址: "",
  是否开启通用课: "",
  学员到期时间: "",
  永久有效: "",
  收藏时间: "",
  是否学习: "",
  章节完成率: "",
  确认废弃当前学习记录: "",
  已废弃: "",
  完成状态: "",
  更新成绩: "",
  更新考试成绩: "",
  考试成绩不能为负: "",
  "学员名称、课程名称模糊匹配": "",
  学习记录明细: "",
  请输入学员UID: "",
  确认不通过此审批信息吗: "",
  确认通过此审批信息吗: "",
  序号: "",
  岗位: "",
  审核类型: "",
  申请时间: "",
  是否转正: "",
  批量修改类型群组: "",
  批量删除: "",
  主体匹配: "",
  代理商简称匹配: "",
  重置完善信息审核次数: "",
  "类别(用户输入)": "",
  类别: "",
  "主体信息(用户输入)": "",
  手机号: "",
  更新类型: "",
  手动更新: "",
  自动更新: "",
  到期时间: "",
  锁定: "",
  解锁: "",
  转正: "",
  主体变更: "",
  学员信息详情: "",
  收藏课程: "",
  学习记录: "",
  选择到期时间: "",
  主体信息匹配: "",
  数据下载: "",
  数据范围: "",
  提交保存信息: "",
  下载指定数据: "",
  变更主体信息: "",
  提交信息: "",
  学员代理主体匹配模板: "",
  批量修改成功: "",
  学员主体数据: "",
  确认变更为当前主体: "",
  确认让学员重新填报信息吗: "",
  驳回成功: "",
  确认删除学员吗: "",
  请选择学员类别: "",
  请输入uid: "",
  请选择文件: "",
  确认转正该学员吗: "",
  转正成功: "",
  确认锁定该学员吗: "",
  确认解除锁定该学员吗: "",
  解除锁定成功: "",
  锁定成功: "",
  游客名称: "",
  请输入游客名称: "",
  游客状态: "",
  请选择游客转化状态: "",
  待转化: "",
  已转化: "",
  点击时间: "",
  转化状态: "",
  转化UID: "",
  转化时间: "",
  请输入要操作的key: "",
  标签名: "",
  新增一个Type值: "",
  请输入字典值: "",
  请输入类型: "",
  添加根菜单: "",
  菜单名称: "",
  菜单类型: "",
  路由地址: "",
  权限标识: "",
  请选择菜单类型: "",
  Vue组件地址: "",
  "注:数字越大越靠前": "",
  父菜单名称: "",
  隐藏式菜单路由: "",
  请输入菜单名称: "",
  功能菜单: "",
  角色名称: "",
  请输入角色名称: "",
  添加角色: "",
  角色权限: "",
  编辑角色: "",
  新增角色: "",
  请选择角色权限: "",
  用户名称: "",
  请输入用户名称: "",
  添加用户: "",
  名称: "",
  登录名: "",
  当前角色: "",
  是否锁定: "",
  解除锁定: "",
  新增用户: "",
  联系邮箱: "",
  登录密码: "",
  权限角色: "",
  请选择权限角色: "",
  编辑用户: "",
  "注:如需修改密码请填写": "",
  "请输入数字，英文或英文符号": "",
  请输入登录名: "",
  请输入登录密码: "",
  确认锁定该用户吗: "",
  确认解除锁定该用户吗: "",
  公司名称: "",
  销售姓名: "",
  行业: "",
  账号: "",
  请输入账号: "",
  密码: "",
  请输入密码: "",
  验证码: "",
  请输入验证码: "",
  登录: "",
  填报明细: "",
  确认: "确认",
  搜索: "搜索",
  精品课: "精品课",
  请输入学员名称: "请输入学员名称",
};
